<template>
  <div id="container" class="scrollView">
    <a-spin :spinning="tableReloading" :tip="loading == true ? '正在导出中' : ''">
      <div :style="scrollView" style="    width: 100%;   padding: 20px 40px;" class="scrollViewPage">
        <div style="display: flex;margin-bottom: 20px;    align-items: center;">
          <a-range-picker format="YYYY-MM-DD HH:mm:ss" show-time v-model:value="rangeTime" @change="changeTime" />
          <div class="datelist">
            <a @click="toSearchUser(1)">近一日</a>
            <a @click="toSearchUser(7)">近一周</a>
            <a @click="toSearchUser(30)">近一月</a>
          </div>
          <a-button type="primary" style="width: 100px;margin-left: 20px;background: #00b2b9;
               border-color: #00b2b9;" @click="toExport" :disabled="!(rangeTime && rangeTime.length > 0)"
            :class="{'exportButton':(rangeTime && rangeTime.length > 0)}">
            导出
          </a-button>
        </div>
        
        <div style="display: flex; width: 100%;">

          <div style="flex: 1;">
              <div style="width: 100%; height: 20rem">
              <div id="readCategoryCompanyPanel" ref="readCategoryCompanyPanel" style="width: 100%; height: 98%"></div>
      
            </div>
          </div>
          <div style="display: flex; flex-direction: column; width: 30%;  ">
            <div style="flex:1 ">
              <div class="smallCard"><span>活跃用户</span><span class="num1">{{count.loginCount}} /
                  {{pagination.total}}</span></div>
            </div>
            <div style="flex:1 ">
              <div class="smallCard"><span>阅读次数</span><span class="num1">{{count.readCount}}</span></div>
            </div>
            <div style="flex:1 ">
              <div class="smallCard"><span>分享次数</span><span class="num1">{{count.shareCount}} </span></div>
            </div>
            <div style="flex:1 ">
              <div class="smallCard"><span>收藏次数</span><span class="num1">{{count.favorCount}}</span></div>
            </div>
            <div style="flex:1 ">
              <div class="smallCard"><span>点赞次数</span><span class="num1">{{count.goodCount}}</span></div>
            </div>
          </div>



        </div>
        <div style="margin-top: 20px;">
          <a-table :columns="columns" :data-source="tableList" bordered class="tablestyle tablestylePage"
            :pagination="pagination">
          </a-table>
        </div>
      </div>
      <div style="display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;">
        <span style="margin-right: 10px;">共{{ pagination.total }} 条</span> <a-pagination
          v-model:current="pagination.current" v-model:page-size="pagination.pageSize"
          :page-size-options="pagination.pageSizeOptions" :total="pagination.total" show-size-changer
          @change="handleTableChange" size="medium" />
      </div>




    </a-spin>

  </div>
  <!--<a-modal  v-model:visible="visible" :bodyStyle="{height:'90%',width:'500px'}">
       <iframe src="https://www.enplus.org.cn/vuePostertest/#/?id=129512&companyId=32&loading=true"></iframe>
    </a-modal>-->
</template>
<script>
import { getReadList, downLoadReadList } from './js/index'
import { reactive, watch, ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import store from '@/store'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue/lib/components'
import * as echarts from "echarts";
import elementResizeDetectorMaker from "element-resize-detector";
const erd = elementResizeDetectorMaker();
export default {
  name: 'readPage',
  setup() {
    // watch(() => store.getters.company, (val) => {
    //   if (val && val != ''&&router.currentRoute.value.path.indexOf('read')>-1) {
    //     var height = document.getElementById('container').offsetHeight
    //     scrollView.value = { height: (height-80 ) + 'px', overflow: 'auto' }
    //     pagination.companyId = store.getters.company.companyId
    //     toShowTable()
    //   }
    // })
    const echartsList = ref([])
    onBeforeUnmount(() => {
      for (var i in echartsList.value) {
        echartsList.value[i].dispose()
        erd.uninstall(echartsList.value[i])
      }

    })
    onMounted(() => {
      rangeTime.value = [dayjs(dayjs().subtract(1, 'day').format('YYYY-MM-DD') + " 00:00:00"), dayjs(dayjs().format('YYYY-MM-DD') + " 00:00:00")]
      var height = document.getElementById('container').offsetHeight
      // scrollHeight.value = height - 180
      scrollView.value = { height: (height - 80) + 'px', overflow: 'auto' }
      if (store.getters.company) {
        pagination.companyId = store.getters.company.companyId
        toShowTable(false)
        // readOutCompanyPanelInit(false);
        
      }

    })
    const dateSize = ref(7)
    const readOutCompanyPanel = ref(null)
    const readCategoryCompanyPanel = ref(null)
    const readCategoryCompanyPanelInit = (result) => {

        if(result==null) return;
        var list = []
        for (var i in result) {
          list.push({ name: i, value: result[i] })
        }
        list=list.sort(function (a, b) { return b.value - a.value });
        var panel  = echarts.init(readCategoryCompanyPanel.value);
        panel .clear();

        panel .setOption({
          title:{
              text:'文章分类阅读统计',
              left:'center',
              bottom:30,
              textStyle:{
                  fontSize:14,
                  color:'#000'
              }
          },
          color: ['#ebf7f8', '#cfedee', '#a7dde0', '#76cacf', '#3db4bb', '#009da6', '#008590', '#006d7a', '#005564', '#003c4d'],
// color: ['#003c4d', '#005564', '#006d7a', '#008590', '#009da6', '#3db4bb', '#76cacf', '#a7dde0', '#cfedee', '#ebf7f8'],
          tooltip: {
            trigger: 'item'
          },

          series: [
            {

              type: 'pie',
              radius: '50%',
              label: {
                normal: {
                  formatter: (params) => {


                    return params.data.name + '，' + params.data.value;

                  },
                },
              },
              data: list,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }),
         echartsList.value.push(panel);

        erd.listenTo(readCategoryCompanyPanel.value, function () {
          nextTick(function () {
            //使echarts尺寸重置
            panel.resize();
          });

        });

     





   

    }
    const toShowTable = (flag) => {

      tableReloading.value = true
      var startTime = ''
      var endTime = ''
      if (rangeTime.value[0] != '') {
        startTime = dayjs(rangeTime.value[0]).format(dateFormat)
        endTime = dayjs(rangeTime.value[1]).format(dateFormat)
      }
      var list = { companyId: pagination.companyId, startTime: startTime, endTime: endTime }
      postData.value = list
      getReadList(list).then((res) => {
        count.value = res.data.count

        // for(var i =0;i<2;i++){
        //   res.data.tableData= res.data.tableData.concat( res.data.tableData)
        // }
        pagination.total = res.data.tableData.length
        // res.data.tableData
        tableList.value = res.data.tableData
        tableReloading.value = false
     
          readCategoryCompanyPanelInit( res.data.categoryData);
       
      })
    }
    const pagination = reactive({
      current: 1,
      pageSize: 100,
      companyId: '',
      total: 0,
      showTotal: function (total) {
        return "共：" + total + " 条";
      },
      pageSizeOptions: ['100', '200'],
    })
    const tableList = ref([])
    const scrollView = ref('')
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const handleScroll = (e) => {
      let scrollTop = e.target.scrollTop; //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight; //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      if (scrollHeight - total < 20) {
        if (articleList.value.length != pagination.total) {
          if (tableReloading.value == false) {
            pagination.current = pagination.current + 1
            toShowTable()
          }
        }
      }
    }
    const reloading = ref(false)
    const tableReloading = ref(false)
    const reloadRComparePanelSpinning = ref(false)
    const visible = ref(true)
    const rangeTime = ref(['', ''])
    const changeTime = () => {
      if (rangeTime.value == null) {
        message.warning('时间不能为空')
      }
      else {
        tableList.value = []
        pagination.current = 1
        toShowTable()
      }
    }
    const scrollY = ref(0)
    const toSearchUser = (val) => {
      pagination.current = 1
      rangeTime.value = [
        dayjs(dayjs().subtract(val, 'day').format("YYYY-MM-DD") + ' 00:00:00'),
        dayjs(dayjs().format("YYYY-MM-DD") + ' 00:00:00')
      ]
      tableList.value = []
      toShowTable()
    }
    const toExport = () => {
      if (tableReloading.value == false) {
        tableReloading.value = loading.value = true
        downLoadReadList(postData.value).then(res => {


          const data = res.data;
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = href;
          downloadElement.download = postData.value.startTime + "-" + postData.value.endTime + '-阅读统计'; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载


          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(href); // 释放掉blob对象
          tableReloading.value = loading.value = false

        }).catch(() => {
          tableReloading.value = loading.value = false
        })
      }

    }
    const loading = ref(false)
    const postData = ref()

    const sumRead = ref(null)
    const panelReloading = ref(false)
    const articleRecordNum = reactive({
      lastLoginClient: 10,
      lastLastLoginClient: 10,
      allClient: 100,
      lastLastDayReadArticleRecord: 10,
      lastLastDayShareArticleRecord: -10,
      lastDayReadArticleRecord: 20,
    })
    const count = ref({})
    const scrollHeight = ref(0)
    return {
      scrollHeight,
      count,
      articleRecordNum,
      dateSize,
      sumRead,
      echartsList,
      readOutCompanyPanel,
      toExport,
      postData,
      loading,
      columns: [
        {
          title: " 序号 ",
          // render: (text, record, index) => `${index + 1}`,  //每一页都从1开始
          customRender: (column) =>
            `${(pagination.current - 1) * pagination.pageSize + column.index + 1
            }`,
          width: "7%",
          align: 'center'
          //当前页数减1乘以每一页页数再加当前页序号+1
        },
        {
          dataIndex: "clientName",
          key: "clientName",
          title: "用户名称",
          align: 'center'
        },
        {
          dataIndex: "loginTime",
          key: "loginTime",
          title: "最后登录时间",
          align: 'center'
        },
        {
          dataIndex: "read",
          key: "read",
          title: "阅读次数",
          align: 'center',
          sorter: (a, b) => {
            return a.read - b.read
          }
        },
        {
          dataIndex: "share",
          key: "share",
          title: "分享次数",
          align: 'center',
          sorter: (a, b) => {
            return a.share - b.share
          }
        },
        {
          dataIndex: "favor",
          key: "favor",
          title: "收藏次数",
          align: 'center',
          sorter: (a, b) => {
            return a.favor - b.favor
          }
        },
        {
          dataIndex: "good",
          key: "good",
          title: "点赞次数",
          align: 'center',
          sorter: (a, b) => {
            return a.good - b.good
          }
        },
      ],
      toSearchUser,
      scrollY,
      changeTime,
      rangeTime,
      visible,

      tableReloading,
      panelReloading,
      reloadRComparePanelSpinning,
      scrollView,
      tableList,
      toShowTable,
      pagination,
      readCategoryCompanyPanel,
      readCategoryCompanyPanelInit
    }
  },
  beforeRouteLeave(to, from, next) {
    //保存滚动条元素div的scrollTop值
    this.scrollY = document.querySelector('.scrollView').scrollTop
    next();
  },
  methods: {
    handleTableChange(page, pageSize) {

      this.pagination.current =
        pageSize != this.pagination.pageSize ? 1 : page;
      this.pagination.pageSize = pageSize;
      this.pagination.current = page
      document.querySelector('.scrollViewPage').scrollTop = 0
    },
  }
}
</script>
<style>
.tablestyle .ant-table-thead>tr>th,
.ant-table-tbody>tr>td {
  padding: 8px 8px !important;
}
</style>
<style lang="scss">
.tablestylePage {
  .ant-pagination {
    display: none;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.smallCard {
  margin: 10px 0px;
  font-size: 14px;
  padding: 3px 9px;
  background: #ebf7f8;
  border: 1px solid #cfedee;
  border-radius: 2px;
  color: #3db4bb;
  font-weight: bolder;
  display: flex;
  align-items: center;

  .num {
    color: #000;
    margin-left: 8px;
    margin-right: 4px;
  }

  .triangleup {
    color: red;
  }

  .num1 {
    font-size: 18px;
    margin-left: auto;
  }

  .triangledown {
    color: #9acd32;
  }
}

.panel.num {
  font-weight: bolder;
  font-size: x-large
}

.dflex {
  display: flex;
}

.tablestyle {
  margin-top: 20px;
}

.scrollView {
  margin: 10px 0px;
  padding: 20px 40px;
  width: 100%;
}

.datelist {
  margin-left: 10px;
  display: inline-block;
}

.datelist a {
  margin-right: 10px;
}
</style>